// 〈올인 선언〉 v1 — 한국어판
// 구조는 MANIFESTO_ZH 와 완전히 대응.
// 저자: ALLIN 커뮤니티

export const MANIFESTO_KO = {
  meta: {
    title: '올인 선언',
    subtitle: '한 가지에 모든 것을 건 사람들을 위한 메모',
    author: 'ALLIN 커뮤니티',
    edition: '초판 · 2026 봄',
  },
  sections: [
    {
      id: 'preface',
      kind: 'preface',
      number: '',
      title: '서문',
      pullQuote: '올인은, 이 세대에서 가장 오해받은 낭만이다.',
      paragraphs: [
        '한 문장으로 시작하고 싶다 — 올인은, 이 세대에서 가장 오해받은 낭만이다.',
        '이것은 백서가 아니다.',
        '백서라면 프로토콜 아키텍처, 합의 메커니즘, 토크노믹스의 정교한 설계를 설명할 것이다. 4단계의 로드맵을 그리고, 모든 단계가 달을 향하는 듯 보이게 만들 것이다. 우리는 그런 글을 쓸 수 없다. $ALLIN은 L1도 아니고 DeFi 프로토콜도 아니며 "기술적 돌파"도 없다 — 컨트랙트는 표준 BEP-20일 뿐, 한 줄의 군더더기 require도 없을 만큼 소박하다.',
        '그렇다면 왜 토큰을 발행하는가?',
        '수십 년간 존재해 왔지만 한 번도 제대로 명명되지 못한 어떤 정신에, 이정표를 세우고 싶기 때문이다. 그것은 버핏에게 있고, 돤융핑에게 있고, 2008년의 머스크에게 있고, 레이쥔의 좁쌀죽에 있고, 자오창펑이 팔아치운 상하이의 그 아파트에 있다. 어느 나라, 어느 업계에도 속하지 않지만, 모든 위대한 결단의 뒤에는 매번 나타났다.',
        '우리는 그것을 **올인**이라 부른다.',
        '토큰은 이 합의를 가격화하고, 권리화하고, 장부에 기록하는 — 가장 빠른 방법이다. 이 〈올인 선언〉, 그리고 그것이 대표하는 이 프로젝트는, 한 가지에 모든 것을 건 모든 이들을 위한 기념비이며, 동시에 지금 그 가장자리에서 망설이는 모든 이들에게 보내는 편지다.',
        '읽고 나서 "이게 바로 나다"라고 느꼈다면 — 테이블로 와도 좋다.',
      ],
      sign: '— ALLIN 커뮤니티',
    },

    {
      id: 'ch1',
      kind: 'chapter',
      number: 'I',
      title: '왜 ALLIN인가',
      paragraphs: [
        '우리는 헤지를 권장하는 시대를 살고 있다.',
        '헤지펀드가 다루는 것은 돈이지만, "헤지"라는 발상은 이미 금융 바깥으로 흘러넘쳐 처세 지혜가 되었다. 투자는 분산하라. 일터에서 한 회사에 올인하지 마라. 인간관계에 백업을 두어라. 시간을 여러 프로젝트에 쪼개라. 시대마다 금과옥조가 있다 — 이 세대의 금과옥조는 "모든 달걀을 한 바구니에 담지 마라"이다.',
        '안전하게 들린다. 대가는 어떤 바구니도 채워지지 않는다는 것이다.',
        '분산을 반대하는 것은 아니다. 자신이 무엇을 하고 있는지 모르는 사람에게는, 분산이 가장 책임감 있는 선택이다. 치명적이지 않은 하방 경계를 제공하기 때문이다. 문제는, 분산이 동시에 비범하지 않은 상방 경계도 만든다는 점이다 — 인생을 평균 회귀 상품으로 바꿔 버린다.',
        '이 세대의 진짜 승자 가운데, 분산으로 만들어진 사람은 한 명도 없다.',
        '버핏의 버크셔는 가장 수익이 좋았던 수십 년 동안, 포트폴리오의 70%를 10개 미만의 종목에 집중시켰다. 그 10개 가운데 하나가 거의 절반을 차지했다. 이것은 분산이 아니다 — 연구를 끝낸 뒤의 집중이다. 돤융핑은 2001년 NetEase에 전 자산을 걸었고, 3년 만에 50배의 수익을 봤다. 레이쥔은 40세 이전에 이미 경제적 자유를 얻었으나, 여러 트랙에 작은 베팅을 흩뿌리는 엔젤투자자로 머물지 않고, 한 회사에 자신을 던지고 그 좁쌀죽 한 그릇을 마셨다. 머스크는 2008년 마지막으로 한 번 더 발사할 수 있는 현금만 남은 상황에서, 그것을 ABC 세 라운드의 "리스크 테스트"로 나누지 않고, 네 번째 발사에 그대로 걸었다.',
        '이들이 공유하는 것은, 어떤 신비로운 도박꾼 기질이 아니다. 정반대다 — 그들은 모두 그 시점, 그 업계에서 연구가 가장 깊고 정보가 가장 풍부하며 리스크 평가가 가장 엄격한 사람 중 하나였다. 그들이 올인할 수 있었던 것은, 꿰뚫어 봤기 때문이다.',
      ],
      pullQuote: '올인은 운에 거는 것이 아니다. 꿰뚫어 본 다음, 모든 칩을 밀어 넣는 용기다.',
      paragraphsAfterQuote: [
        '하지만 이 단어는 지난 십 년 사이 반복적으로 오명을 뒤집어썼다. 많은 이들의 귀에 "올인"은 "도박꾼", "개미의 충동", "전부 박고 0이 되는 일"과 동의어로 들린다. 이는 거대한 의미 절도다. **진짜 올인하는 사람은 결코 운에 의지하지 않는다. 그들이 의지하는 것은 연구의 깊이, 그리고 그 연구를 실탄으로 바꿀 용기다**. 운에 기대는 쪽은 다른 부류다 — "도박꾼"이라 불린다. 그들도 자주 올인하지만, 자신이 근본적으로 이해하지 못하는 무언가에 올인하기 때문에, 0이 되는 것은 필연이다.',
        'ALLIN이 가장 먼저 하고자 하는 일은, 도박꾼들의 손에서 "올인"이라는 단어를 되찾는 것이다.',
        '두 번째는, 비즈니스 엘리트의 사전에서만 사용되던 그 단어를 꺼내, 모든 사람에게 건네는 일이다.',
        '창업자만 올인할 수 있는 것이 아니다. 한 엔지니어가 대기업을 그만두고 자신의 오픈소스 프로젝트에 전력투구하기로 한 것 — 그게 올인이다. 한 학생이 대학에서 한 분야만 배우고 모든 시간을 AI 연구에 쏟기로 한 것 — 그게 올인이다. 한 가족이 베이징의 집을 팔아 자녀의 뉴질랜드 교육에 전부 투자하기로 한 것 — 그게 올인이다. 한 평범한 사람이 모든 여가와 저축을 한 가지 일에 십 년간 쏟기로 한 것 — 그것 또한 올인이다.',
        '올인은 어느 트랙, 어느 자산 규모, 어느 신분에도 속하지 않는다. 오직 하나의 자세에 속한다 — **연구를 끝내고, 전부를 밀고, 결과를 받아들인다**.',
        '그러면 왜 토큰인가?',
        '토큰이 이 세대에서 가장 빠른 합의 컨테이너이기 때문이다. 한 편의 글이 권역을 형성하는 데 몇 년이 걸리고, 한 권의 책이 한 문화를 빚는 데 십 년이 걸리며, 하나의 종교가 안정되는 데 백 년이 걸린다. 그러나 토큰 — 투명하고, 거래 가능하고, 온체인으로 증명되며, 합의에 가격이 매겨지는 — 은 몇 달 안에 사람들을 모으고, 서로를 찾게 하고, 서로를 확인하게 한다.',
        '우리는 $ALLIN이 어떤 "실용적 문제"를 풀기를 기대하지 않는다. 이 토큰에는 실용 기능이 없다. 그것은 기념비이고, 암호이고, 명단이다 — 명단에 오르는 사람은, 자기 인생에서 한 가지에 모든 것을 건 모든 이들이다.',
        '마지막으로 한 줄을 그어둔다 — ALLIN은 Trump 테마도, Doge 후속작도, 어떤 트렌드에 편승한 meme도 아니다. 그것은 중국어 문맥에서 **올인 정신**에 대한 정식 기념비다. 로고의 주먹을 든 황금색 Doge는 Trump의 자세를 빌린 것이 아니다 — 그 자체로 이 세대가 가장 익숙하게 알고 있는, "나는 봤다, 나는 베팅한다"는 신체 언어다.',
        'Doge에서 그 동작은 빌렸지만, 정신은 훨씬 더 깊은 곳에서 왔다.',
      ],
    },

    {
      id: 'ch2',
      kind: 'chapter',
      number: 'II',
      title: '세 가지 정신 원칙',
      paragraphs: [
        '프로젝트의 모든 판단, 모든 결정, 모든 수록 기준은 이 세 조항에서 나온다.',
      ],
      subsections: [
        {
          id: 'ch2-1',
          number: 'I',
          title: '꿰뚫어 봤다면, 올인하라',
          paragraphs: [
            '이 한 조항이 "연구"와 "베팅"의 관계를 바라보는 시각을 결정한다.',
            '업계에는 두 가지 주류 흐름이 있다. 하나는 버핏의 "안전 마진" — 내재가치보다 훨씬 낮은 가격의 자산만 사고, 충분한 완충을 남긴다. 다른 하나는 돤융핑의 "하지 않을 목록" — 평생 하지 않을 일을 적어 놓고, 남은 영역만 연구 범위로 삼는다. 표면에는 두 방법으로 보이지만 본질은 같다 — 중대한 결단 전에, "이해할 수 없는 것"을 전부 깨끗이 걸러내는 일이다.',
            '걸러내고 나면 흥미로운 일이 생긴다 — 베팅할 수 있는 대상이 매우 적어진다.',
            '얼마나 적은가? 버핏은 가장 큰 수익을 낸 수십 년 동안, 한 해 평균 한두 개의 진짜 중대한 베팅만 했다. 돤융핑은 인생의 중대한 결단이 다섯 번을 넘지 않으며, 매번 집중해서 걸었다고 공개적으로 인정했다. 그들이 게을러서가 아니다 — **진짜로 꿰뚫어 볼 수 있는 대상은 본래 많지 않다**는 사실을 알고 있기 때문이다.',
            '여기서 거꾸로 한 가지 결론이 나온다 — 어떤 일을 진짜로 꿰뚫어 봤을 때, 분산해서 베팅하는 것은 일종의 자기 배신이다.',
            'NetEase를 끝까지 연구해서 현금 보유고가 시가총액을 넘는다는 사실을 확인했다면, 왜 10%만 사는가? 90%의 연구 작업을 끝냈다면, 남은 10%를 박지 않을 이유는 무엇인가? 자신의 연구를 의심하는 게 아니라면 — 만약 의심한다면 더 연구해야지, "분산"으로 자기 불확실성을 가리는 게 아니다.',
            '켈리 공식은 이 사실에 수학적 근거를 더해 준다. 승률과 배당률이 알려졌을 때, 최적 베팅 비율은 일반 투자자가 감히 거는 금액보다 훨씬 큰 경우가 많다. 승률 60%, 배당률 1.5:1의 기회에 켈리는 자금의 33%를 권한다 — 5%도 10%도 아니다.',
            '"꿰뚫어 봤다면 올인하라"고 말할 때, 우리는 충동을 부추기는 것이 아니다. 두 부류의 사람을 떠나보내려는 것이다 —',
          ],
          list: {
            items: [
              '**첫째, 사실은 꿰뚫어 보지 못했는데 FOMO에 떠밀려 베팅하는 사람.** 그건 도박이다. 다시 연구하라.',
              '**둘째, 꿰뚫어 봤지만 조금만 거는 사람.** 그건 비겁함이다. 확신을 현금화하라.',
            ],
          },
          paragraphsAfterList: [
            '그 사이의 좁은 길이 바로 올인이다.',
            '"꿰뚫어 봤다"의 최소 기준으로 세 가지를 제안한다 —',
          ],
          checklist: {
            items: [
              '5분 안에, 그 분야를 모르지만 똑똑한 사람에게 핵심을 설명할 수 있다.',
              '이 베팅이 실패할 세 가지 경로를 들 수 있고, 각각의 확률을 가늠할 수 있다.',
              '최악의 경우에도 당신의 삶은 계속될 수 있다. "갚을 수 없는 빚"이나 "되돌릴 수 없는 관계"가 생기지 않는다.',
            ],
          },
          paragraphsTail: [
            '세 번째 조항이 특히 중요하다. 우리는 무모한 베팅을 권하는 게 아니다 — 올인과 무모한 도박의 경계를 긋는 것이다. 진짜 올인하는 사람은 "잃어도 견딜 수 있는 전부"를 거는 것이지, "빌릴 수 있는 전부"를 거는 것이 아니다. 이는 자기 삶에 대한 정직한 절제다.',
          ],
        },

        {
          id: 'ch2-2',
          number: 'II',
          title: '결과를 받아들여라',
          paragraphs: [
            '이 한 조항이 우리 자신, 홀더, 시장에 대한 태도를 결정한다.',
            'ALLIN은 수익을 약속하지 않는다.',
            '한 번 더 강조하고 싶다 — ALLIN은 **수익을 약속하지 않는다**. 이 토큰의 컨트랙트에는 스테이킹 APY도 없고, 바이백 소각 머신도 없으며, 정기 분배도 없다. 우리는 어떤 KOL의 영상에서도 "100x 간다"고 말하지 않을 것이고, 어떤 X 게시물에서도 "목표가"를 그리지 않을 것이다.',
            '우리가 약속하는 것은 단 하나, 진실이다.',
            '컨트랙트는 진실하다 — LP는 영구 소각되었고, 온체인에서 검증할 수 있다. 분배는 진실하다 — 팀 보유분도, 어드바이저 언락도 없다. 이야기는 진실하다 — 수록된 모든 올인 사례는 공개적으로 검증 가능한 자료에 기반한다. 그뿐이다.',
          ],
          pullQuote: '우리는 꿈을 팔지 않는다. 정직한 계약 한 장을 내놓을 뿐이다 — 보이는 그대로가 전부다.',
          paragraphsAfterQuote: [
            '이는 우리가 두 가지 업계 관성을 능동적으로 거부해야 함을 뜻한다.',
            '첫 번째는 "로드맵 마법"이다. 대부분의 토큰 프로젝트는 Phase 1 / 2 / 3 / 4를 그리고, 모든 단계가 정확하고, 리듬감 있고, 막을 수 없는 듯 보이게 만든다. **우리에게는 Phase 4가 없다**. 우리는 지금 실행할 수 있는 일만 약속하고, 1년 뒤에 무슨 일이 벌어질지는 약속하지 않는다 — 커뮤니티 합의 자체가 유동적이기 때문이다. 내년의 진로는 내년의 커뮤니티가 결정해야지, 오늘 문서를 쓰는 사람이 결정해서는 안 된다. 전문적이지 않게 들릴 수 있지만, 정직하다.',
            '두 번째는 "합의의 유지"다. 한 meme 코인이 달리기 시작하면, 운영진이 흔히 하는 일은 — 단톡 모집, 콜 외치기, 매수 주문 배치, 정서 안정, 가격이 너무 빠지지 않게 하기. 우리는 그러지 않는다. **ALLIN의 등락은 커뮤니티의 그 순간의 진짜 신앙 강도를 그대로 반영한다** — 합의가 강하면 가격은 자연히 오르고, 합의가 약하면 가격은 자연히 내린다. 약해진 순간에 어떤 수단으로도 "받쳐주지" 않을 것이다. 받쳐주는 것은 홀더에게 가장 큰 부정직이며, "아직 지키는 사람이 있다"는 환상을 만들고, 결국 그 환상을 믿은 사람이 계산을 떠안기 때문이다.',
            '결과를 받아들이는 것의 핵심은, 이 일이 0이 될 수 있음을 인정하는 것이다.',
            '반드시 0이 된다는 말이 아니다. 우리 — 프로젝트, 코어 홀더, 커뮤니티 기여자 — 모두가 그 가능성을 100% 알고 있고, 알고도 여전히 테이블에 남기로 선택한다는 뜻이다. 이 "알고도 남는다"가 ALLIN의 유일하게 신뢰할 만한 해자다.',
            '홀더에게: 잃어도 견딜 수 있는 돈으로 걸어라. 우리가 말하는 "견딜 수 있다"는 금액이 아니다 — 이 돈이 0이 되어도 당신의 삶, 관계, 건강이 질적으로 변하지 않는 정도를 뜻한다. 갚을 수 없는 돈으로 올인하고 있다면, 당신은 이 선언의 독자가 아니다. 당신은 도박꾼이다. 떠나라.',
            '공개적으로 지는 것 또한 자랑이다.',
            '언젠가 $ALLIN이 0이 된다면, 커뮤니티는 마지막 기록을 공개할 것이다 — 수록된 모든 이야기, 모든 기여자, 모든 온체인 데이터를 정리하여 봉인할 것이다. 몰래 사라지지 않을 것이고, 이름을 바꿔 재시작하지 않을 것이며, 다른 프로젝트로 세탁되지 않을 것이다. **진 이야기도 이긴 이야기와 똑같이 기록될 가치가 있다** — 그 순간에 모든 것을 건 사람의 용기를, 동등하게 진실하게 짊어지고 있기 때문이다.',
          ],
        },

        {
          id: 'ch2-3',
          number: 'III',
          title: '장기주의자와만 동행한다',
          paragraphs: [
            '이 한 조항이 우리가 누구를 끌어들이고, 누구를 멀리하고 싶은지를 결정한다.',
            '가장 오해받기 쉬운 것은 "장기주의"라는 네 글자다. 지금은 거의 의미를 잃을 만큼 남용되고 있다 — 30% 빠진 주식이 물려서 못 파는 것을 "장기 보유"라 부르고, 7년 동안 진척 없는 일을 떠나지 못한 것을 "장기 투입"이라 부르며, 이미 서로를 소진한 관계를 정리하지 못한 것을 "장기 약속"이라 부른다. 이런 것들은 장기주의가 아니다.',
          ],
          pullQuote: '장기주의는 수동적인 기다림이 아니다. 매년이 마지막 해일 수도 있다고 여기면서, 그래도 계속 베팅하기로 선택하는 자세다.',
          paragraphsAfterQuote: [
            '능동적이고, 끊임없이 재평가되며, 언제든 떠날 수 있지만 떠나지 않기로 선택한 자세다. 매몰비용 때문에 움직이지 못하는 것이라면, 그건 장기주의가 아니라 관성이다.',
            'ALLIN이 찾는 동행자는 "올인"을 일회성 사건이 아니라 삶의 방식으로 여기는 사람이다. 즉 —',
          ],
          checklist: {
            items: [
              '자신의 연구를 지속적으로 의심하고, 반증이 보이면 조정하는 사람.',
              '이길 때 떠벌이지 않고, 질 때 사라지지 않는 사람.',
              '전부를 걸지만 늘 "다음으로 가장 중요한 일"에 걸 뿐, 과거의 그 일에 머물지 않는 사람.',
              '다른 장기주의자에게 자연스러운 존경을 가지는 사람 — 트랙이 다르고 판단이 달라도.',
            ],
          },
          paragraphsTail: [
            '그래서 ALLIN의 핵심 콘텐츠는 거인들의 올인 이야기를 수록하는 일이다. 이 이야기들은 "신앙 마케팅"의 재료가 아니다 — 우리와 동행자들에게 보내는 메모다 — **올인은 어느 한 시대만의 것이 아니다. 모든 세대에 있고, 모든 업계에 있다**.',
            '우리는 긴 명단을 남기고 싶다.',
            '명단에 오를 사람은 런정페이 같은 산업가, 버핏 같은 자본가, 머스크 같은 엔지니어, 저스틴 선 같은 크립토 플레이어, 왕싱 같은 연쇄 창업자일 수도 있다. 또는 우리가 아직 들어본 적 없는, 어느 작은 도시의 셋방에서 한 가지 일에 모든 시간을 쏟고 있는 청년일 수도 있다. 이 명단은 국적, 업계, 계급을 가리지 않는다 — 유일한 입장권은 한 가지에 모든 것을 걸었다는 사실이다.',
            '지금 그런 일을 하고 있다면 — 투고하라. 제3장 〈올인의 인물전〉은 계속 갱신되고, 채택된 모든 이야기는 온체인과 이 선언 안에 영구히 보존된다. 우리는 토큰 풀의 10%를 채택자들에게 배분할 것이다. 다만 솔직히 말하면 — **이 프로젝트에 진짜 끌리는 사람은 그 10% 때문에 오지 않는다 — 그들은 기록되기 위해 온다**.',
            '기록된다는 것은 오래된 보상의 형태다. 토큰보다 훨씬 오래되었고, 아마 훨씬 오래간다.',
          ],
        },
      ],
    },

    {
      id: 'ch3',
      kind: 'chapter',
      number: 'III',
      title: '올인의 인물전',
      paragraphs: [
        '이 장은 숭배를 위한 것이 아니다.',
        '우리는 이 아홉 명을 신격화하고 싶지 않다 — 모두 자기 한계, 논쟁, 실수를 가지고 있다. 런정페이는 "늑대 문화"로 알려졌지만 직원들을 쥐어짜기도 했고, 돤융핑도 가끔은 잘못 보며, 머스크의 X 인수는 지금도 논란이 끊이지 않고, 저스틴 선의 여러 사업 결정은 SEC에 제소되었다.',
        '우리가 기록하고 싶은 것은 그 사람 자체가 아니라, 그들이 어느 구체적인 순간에 내린 "올인" 결단이다. 그 순간 그들은 모두 절벽 끝에 서서, 모든 칩을 밀어 넣었다. 그 순간의 용기, 그 순간의 판단, "보고 나면 망설이지 않는다"는 그 순간의 자세 — 이것을 우리는 남기고 싶다.',
        '아홉 명, 아홉 개의 다른 업계, 아홉 개의 다른 베팅. 그러나 그들은 한 가지 자세를 공유한다.',
        '시간순으로 — 1987년 선전 난유의 한 방에서, 2017년 카메라 앞까지.',
      ],
      subsections: [
        {
          id: 'ch3-1',
          number: '01',
          title: '런정페이 · 2.1만 위안의 출발 (1987)',
          paragraphs: [
            '1944년 구이저우 산간에서 태어났다. 런정페이는 일곱 자녀의 중학 교사 가정에서 자랐다. 아버지도 가르쳤고, 어머니도 교사였지만, 자식이 많고 수입은 얇았다. 문화대혁명이 시작되자 아버지는 "우파" 혐의로 비판받고, 격리되고, 강제 노동에 보내졌다. 장남으로서 동생들을 돌볼 책임은 그에게 떨어졌다. 훗날 그는 회상한다 — 18세에 충칭 건축공학원에 들어가기 전까지 "한 번도 배불리 먹어본 적이 없었다"고.',
            '1968년 대학을 졸업하고 군대 기반시설 공병부대에 배치되어 엔지니어가 되었다. 14년간의 군 생활 동안 평기술자에서 부연대장급까지 올랐다. 1983년 부대 정비 개편에 따라, 수십만의 군인과 함께 전업하여 선전 난하이 석유 후방 보급 기지에 배치되었다.',
            '1987년 어느 날, 런정페이는 한 거래에서 200만 위안을 사기당했다 — 당시의 그에게 몇 평생 분의 봉급에 해당하는 금액이었다. 아내는 이혼을 신청했고, 아버지는 구이저우의 고향에서 병으로 세상을 떠났다. 43세, 실업, 부채, 독신, 두 자녀와 노모를 부양해야 하는 처지가 동시에 닥쳤다.',
            '1987년 9월 15일. 선전 난산구 난유 신촌 A3동 16층 16D. 80평방미터도 안 되는 평범한 아파트. 런정페이와 다섯 친구는 21,000위안 — 그중 몇 천 위안은 친지에게 빌린 돈이었다 — 을 모아 회사를 등록했다.',
            '회사 이름은 "화웨이". "중화에 할 일 있다(中華有為)"의 줄임말이다.',
            '첫해, 화웨이는 구내 교환기 대리상에 불과했다. 런정페이는 직접 영업을 뛰고, 계약을 협상하고, 수금을 독촉하고, 장비를 설치했다. 선전의 여름 38도, 그는 와이셔츠 차림으로 한 집 한 집 고객을 찾아갔다. 한 초기 직원은 그를 "뼈만 남았다"고 기억한다.',
            '하지만 대리 사업의 두 번째 해, 그는 화웨이의 30년을 결정짓는 결단을 내렸다 — 자체 개발에 들어간다.',
            '당시 중국의 통신 시장은 "7국 8제"에 독점되어 있었다 — 7개국 8가지 표준, 모두 서양 브랜드였다 — 루슨트, 노텔, 알카텔, 지멘스, 후지쯔, 에릭슨, NEC… 국산은 거의 전무했다. 런정페이는 대리 사업에서 나오는 모든 이익을 R&D에 쏟아부었다.',
            '1991년 하반기, 자체 개발한 HJD48이 양산에 성공했다. 1993년, 화웨이는 그해 회사 전체 이익에 해당하는 5,000만 위안을 만 회선급 교환기 C&C08 개발에 투입했다. 또 한 번의 올인 — R&D가 지연되면 회사는 파산한다.',
            '1994년 C&C08이 양산에 성공했다. 그해 매출은 8억 위안을 돌파했다. 연말 행사에서 런정페이는 이후 거듭 인용되는 한마디를 남긴다 —',
          ],
          pullQuote: '"십 년 안에 세계 통신 제조업은 셋으로 갈라질 것이다. 화웨이가 그 가운데 하나다."',
          paragraphsAfterQuote: [
            '런정페이의 올인은 도박형이 아니라 절경형이었다. 1987년의 그에게는 "분산해서 베팅"할 자격이 없었다 — 분산할 돈이 없었고, 쪼갤 수 있는 두 번째 기회도 없었다. 200만 위안 사기, 부채, 이혼, 아버지의 죽음 — 이 모든 것이 그를 "한 가지에 올인할 수밖에 없는" 자리로 밀어 올렸다.',
            '하지만 **어디에** 올인할지는 판단의 결과였다. 1987년의 중국 통신업은 황무지였다 — 한쪽에는 국가의 시급한 수요(전화 보급률 1% 미만), 다른 한쪽에는 사실상 부재한 국산 플레이어. 런정페이는 거기서 30년급의 창문을 보았다 — 통신망은 한번 깔리면 갱신 속도가 인프라처럼 느리고, 선발 우위가 구조적으로 쌓인다.',
            'C&C08은 그의 두 번째 "절경형" 결단이었다. 1993년의 5,000만 위안 R&D 투자는, 직원 270명의 화웨이에게 그해 전부의 이익을 한 데 거는 일이었다. 인도가 실패하면 — 반년 늦는 정도가 아니라 품질 미달 — 화웨이는 즉시 파산한다.',
            '훗날 그는 〈화웨이의 겨울〉, 〈북국의 봄〉을 직접 썼다 — 사내 강연 시리즈, 모두 한 가지 주제를 둘러싼다 — **위기감이 화웨이의 유일한 해자다**.',
            '1996년 해외로 확장. 2002년 유럽 진출. 2010년 세계 2위 통신 장비 회사. 2018년 에릭슨을 넘어 1위. 2018년 12월 멍완저우가 캐나다에서 체포되며 미국의 화웨이 제재가 시작된다. 2020년 제재가 격화되어 TSMC의 칩 공급이 끊겼고, 휴대폰 사업은 한때 70%의 매출을 잃었다.',
            '사내 강연에서 런정페이는 단 두 문장만 남겼다. "가장 어려운 순간은 아직 뒤에 있다." "눈물을 닦고 계속 나아가자."',
            '2023년 8월 29일, 화웨이 Mate 60 Pro가 예고 없이 발매되었다. 완전 자체 개발한 Kirin 9000s 칩을 탑재했다. 해외 테크 매체는 발칵 뒤집혔다 — 죽었다고 여겨진 화웨이의 칩 설계 능력이, 국산 공정으로 되살아났다.',
          ],
          checklist: {
            items: [
              '**절경형 올인이 가장 순수하다** — 퇴로가 없으면 망설일 수 없다.',
              '**43세의 창업이 늦지 않다** — "나이의 우위"를 빼고 남는 것은 판단력과 끈기다. 그 둘은 나이로 사라지지 않는다.',
              '**30년급의 트랙을 골라라** — 통신, 전력, 의료. 갱신 주기가 긴 산업에서는 선발 우위가 쌓인다.',
              '**위기감이 해자다** — 런정페이가 30년에 걸쳐 보여준 것은, 위험한 것은 위기 자체가 아니라 위기감의 부재라는 점이다.',
            ],
          },
        },

        {
          id: 'ch3-2',
          number: '02',
          title: '돤융핑 · NetEase 바닥잡기 (2001)',
          paragraphs: [
            '1961년 장시성 난창 출생. 1989년 28세의 돤융핑은 광둥성 중산의 도산 직전 작은 공장 — 르화 전자(日華電子廠)에 합류했다. 첫 번째로 한 일은 공장이 보유한 8비트 패미컴 호환기를 "샤오바왕(小霸王) 학습기"로 새로 포장하는 것이었다. 1992년 청룽을 광고 모델로 기용했다 — "샤오바왕 한 대면, 마이크로컴퓨터실 하나가 생긴다." 광고비는 5,000만 위안 — 그해 중국 전체 TV 광고 예산의 짜투리에 가까운 액수였다.',
            '1995년 샤오바왕은 매출 10억 위안에 도달했다. 그러나 돤융핑이 사장에게 지분 개편을 요구했고, 거절당했다. 그는 핵심 팀을 데리고 떠나, 둥관에서 "BBK(步步高)"를 세웠다 — 무선 전화기, 리피터, DVD, 이후 음악 휴대폰. 같은 청룽 광고, 같은 마케팅, 같은 캐시카우.',
            '2001년 40세의 돤융핑은 BBK의 경영을 팀에 넘기고 본인은 미국 실리콘밸리로 이주했다. "반은퇴" — 독서, 골프, 투자 연구가 계획이었다.',
            '2001년은 닷컴 붕괴가 가장 참혹했던 해였다. 나스닥은 5,048에서 1,100으로 떨어졌다. 미국에 상장된 중국 개념주는 처참하게 두들겨 맞았다.',
            'NetEase(NTES)는 그중 가장 심하게 떨어졌다. 2001년 7월, 2000년 연차 보고서의 부정확한 공시로 SEC의 조사를 받았고, 주가는 IPO 당시 15달러에서 그해 9월 0.6달러까지 떨어졌다 — 96% 하락. 거래 재개 후에도 거의 누구도 이 주식에 손을 대지 않았다.',
            '돤융핑은 미국에 막 도착해 미국 주식을 들여다보기 시작했다. NetEase의 재무를 펼쳐 보니 —',
          ],
          list: {
            items: [
              '회사 보유 현금 4,400만 달러',
              '당시 시가총액 2,000만 달러 미만',
              '주력 사업(MMO 〈大話西遊 II〉, 메일, 광고) 모두 양(+)의 현금흐름',
              '창업자 딩레이가 50% 보유, 본인은 도망가지 않음',
            ],
          },
          paragraphsAfterList: [
            '한 줄로 — **이 회사 장부의 현금이 시가총액보다 많다**. 산다는 것은 50센트로 1달러의 현금을 사는 것과 같다.',
            '돤융핑은 200만 달러를 들여 NetEase를 매수했다.',
          ],
          pullQuote: '"나는 인터넷을 깊이 이해하지 않는다. 다만 인간 본성에 대해서는 충분히 이해한다."',
          paragraphsAfterQuote: [
            '논리는 단순했다. 첫째, 이는 전형적인 "안전 마진" 사례다 — NetEase가 내일 문을 닫아도 청산 후 주주가 받는 돈은 주가보다 많다. 하방 리스크는 현금으로 잠겨 있었다. 둘째, 딩레이는 아는 사람이었다 — BBK 시절 사업적으로 왕래가 있었고, 도망가지 않을 인물이라 믿었다. 셋째, 딩레이는 〈몽환서유(夢幻西遊)〉라는 게임을 팀과 함께 만들고 있었다. 회사에 현금, 팀, 제품 방향이 있었고, 부족한 것은 시장의 정서뿐이었다.',
            '돤융핑은 훗날 말했다 — "내가 건 것은 NetEase가 반드시 오른다는 것이 아니다 — 0이 되어도 받아들이겠다는 것이었다."',
            '포지션 사이즈도 핵심이다. 200만 달러는 그의 전 자산은 아니었지만, 단일 종목 최대 포지션 중 하나였다. 이는 분산형 "안전 마진"이 아니라, 연구를 끝낸 뒤의 집중 베팅이었다.',
            '2003년 초, 〈몽환서유〉가 출시되어 빠르게 중국에서 가장 국민적인 클라이언트 MMO가 되었다. NetEase 주가는 0.6달러에서 70달러로 폭발했다 — 18개월에 100배. 돤융핑의 200만 달러는 약 2억 달러가 되었다. 그러나 그는 팔지 않았다. 20년이 넘도록 NetEase를 보유했고, 점차 줄여나갔지만 한 번도 전부 처분하지 않았다.',
            '두 번째 올인은 2011년이었다. 잡스가 세상을 떠났고, 시장은 애플이 영혼을 잃을 것을 우려해 주가가 조정받았다. 돤융핑은 애플을 대량 매수했다. 이유 — "애플의 iOS 생태계, 제품 철학, 사용자 락인은 한 사람이 떠난다고 사라지지 않는다." 10년 뒤, 애플 주가는 그의 평균 매수가에서 3-4배 올랐다.',
            '중간에 작은 베팅도 있었다 — 2010년대의 텐센트, 2018년의 마오타이. 매번 끝까지 연구한 뒤 큰 베팅을 했고, 분산형 도박은 한 번도 없었다.',
          ],
          checklist: {
            items: [
              '**현금이 시가총액을 넘는 종목은 신급의 안전 마진**. 이런 기회는 평생에 다섯 번을 넘지 않는다. 만나면 조금만 걸지 마라.',
              '**"하지 않을 목록"이 to-do보다 중요하다**. 하지 않을 영역, 익숙하지 않은 업계, 이해 안 되는 비즈니스 모델을 모두 걸러내고, 남은 것을 연구 범위로 삼아라.',
              '**큰 베팅 + 장기 보유가 단타보다 더 번다**. 돤융핑의 평생 진짜 큰 결단은 다섯 번을 넘지 않는다. 그러나 매번 큰 베팅이었고, 사업 자체가 변할 때까지 보유했다.',
              '**가치투자 ≠ 집중 불가**. 버핏도 돤융핑도 모두 집중파다. "분산은 무지한 자의 피난처" — 버핏 원문.',
            ],
          },
        },

        {
          id: 'ch3-3',
          number: '03',
          title: '머스크 · 네 번째 발사 (2008)',
          paragraphs: [
            '1971년 남아프리카 프리토리아에서 태어났다. 10세에 첫 컴퓨터를 가졌고, 12세에 Blastar라는 게임을 500달러에 팔았다. 17세에 남아공을 떠나 캐나다로 향했다 — 의무 복무를 피하기 위해서이기도 했다.',
            '1995년, 24세의 머스크는 스탠퍼드 물리학 박사 과정에 입학했지만 이틀 만에 자퇴하고 동생과 Zip2를 시작했다. 1999년 Zip2를 컴팩에 매각, 그의 손에 들어온 돈은 2,200만 달러. 같은 해 그는 그 대부분을 들여 X.com을 세웠다 — 온라인 은행. 이후 X.com은 Confinity와 합병해 PayPal로 개명한다. 2002년 eBay가 PayPal을 인수했고, 최대 개인 주주였던 머스크는 1억 8,000만 달러를 손에 넣었다.',
            '"분산 투자"나 "조기 은퇴"를 택했다면 31세부터 평생 엔젤투자자로 살 수 있었다. 그러나 그는 정반대의 일을 했다.',
            '2002년 6월, 1억 달러로 SpaceX를 창업. 2004년 남은 7,000만 달러로 Tesla에 투자하고 CEO가 된다. 2006년 SolarCity 공동 창립에 참여.',
            '2008년에 이르러, 그의 세 회사는 모두 파산 직전이었다.',
            '2008년은 머스크 인생에서 0에 가장 가까웠던 해다. SpaceX는 Falcon 1을 세 번 발사했고, 세 번 다 실패했다 —',
          ],
          list: {
            items: [
              '2006년 3월 24일 — 발사 33초 후 연료관 누유, 로켓 추락',
              '2007년 3월 21일 — 1단과 2단 분리 중 충돌, 통제 상실',
              '2008년 8월 3일 — 2단 조기 정지, 페이로드 궤도 진입 실패',
            ],
          },
          paragraphsAfterList: [
            'SpaceX의 보유 현금은 마지막 한 번만 더 발사할 수 있는 액수였다.',
            'Tesla의 상황은 더 나빴다. Roadster는 1년 넘게 출하 지연, 공장 건설은 예산 초과, 2008년 금융 위기로 모든 VC가 지갑을 닫았다. Tesla는 그달의 급여를 줄 현금조차 없었다.',
            '머스크의 1억 8천만 달러 — PayPal 매각 이후 그가 가졌던 모든 돈 — 은 이미 두 회사에 투입되었고, 그 위에 그가 직접 태운 수천만 달러가 얹혀 있었다. 2008년 9월 인터뷰에서 그는 말했다 — "지금 내게 남은 것은 아내의 차와 아이들의 학자금 펀드뿐이다."',
            '그해 가을, 그는 결정한다 — 마지막 3,000만 달러를 — 그가 동원할 수 있는 현금 전부를 — SpaceX의 네 번째 발사에 전부 투입한다.',
            '2008년 9월 28일, Falcon 1 네 번째 발사. 이번에는 성공했다. Falcon 1은 민간 기업이 개발해 궤도에 올린, 인류 최초의 액체 연료 로켓이 되었다. 곧이어 2008년 12월 23일(크리스마스 이틀 전), NASA는 SpaceX에 16억 달러의 화물 운송 계약을 안겼다. 같은 시기 Tesla는 12월 말 4,000만 달러의 D 라운드 투자 유치를 마무리하고, 머스크가 결혼반지와 집을 담보로 빌린 2,000만 달러를 더해, Tesla는 그 크리스마스를 넘겼다.',
          ],
          pullQuote: '"이 로켓을 날리거나, 이 회사가 죽거나. 세 번째 옵션은 없다."',
          paragraphsAfterQuote: [
            '2008년 9월의 그 올인 지점에서 머스크의 선택지는 — A. 3,000만 달러를 세 회사에 분배. B. 자동차 시장이 더 크다는 이유로 Tesla에 전액. C. SpaceX 네 번째 발사에 전액, 한 번의 성공에 베팅.',
            '그는 C를 골랐다. 이유는 셋.',
            '첫째, **SpaceX의 수학은 확정적이었다**. 로켓의 실패 모드는 한정적이고, 앞선 세 번의 실패 원인은 이미 모두 수정되었다. 네 번째의 승률은 그가 계산할 수 있는 값이었다. Tesla의 시장 반응, 소비자 수용도, 금융 환경 — 이런 것은 그가 계산할 수 없었다.',
            '둘째, **SpaceX가 성공하면 즉시 NASA 계약이 풀린다**. 이는 "내가 이기면 상금은 이미 길에 있다" 식의 베팅이었다. 머스크는 2008년 초 NASA와 COTS 협정에 서명했다 — 발사 성공이 곧 결제의 잠금 해제였다.',
            '셋째, **Tesla에는 자금 조달의 여지가 남아 있었지만, SpaceX에는 없었다**. VC는 로켓에 투자하지 않는다. SpaceX는 자기 증명(한 번의 성공 발사)으로만 그 상황을 바꿀 수 있었다.',
            '2024년 시점에 SpaceX는 4,000억 달러를 넘어선 평가를 받는다(세계에서 가장 비싼 비상장 기업). Tesla의 시가총액 정점은 1조 5천억 달러를 넘었다. 그러나 이 모든 것은 "올인이 성공한 뒤의 이야기"다. 만약 2008년 9월 28일의 발사가 실패했다면, 누구도 SpaceX를 기억하지 못할 것이고, Tesla는 2009년 초에 파산했을 것이다.',
          ],
          checklist: {
            items: [
              '**계산 가능한 베팅은 집중해도 된다**. 머스크가 2008년 SpaceX에 전액 걸 수 있었던 것은, 네 번째 발사의 모든 실패 모드를 열거할 수 있었고 각각의 해법이 있었기 때문이다.',
              '**한 번의 성공으로 규칙이 바뀌는 일에 걸어라**. NASA 계약은 머리 위에 매달린 상금이었다. 머스크는 한 번의 성공이 얼마를 풀어주는지 알고 있었다.',
              '**결혼반지는 담보 잡힐 수 있다, 시간은 그럴 수 없다**. 현금이 부족할 때 자산은 현금화할 수 있다. 그러나 시간이 부족할 때, 어떤 것도 그 자리를 대신하지 못한다.',
              '**"All In"은 일회성 사건이 아니다**. 2008년의 올인 이후, 2018년 Tesla 양산 위기에서 다시 올인, 2022년 Twitter 인수에서 또 올인.',
            ],
          },
        },

        {
          id: 'ch3-4',
          number: '04',
          title: '레이쥔 · 한 그릇의 좁쌀죽 (2010)',
          paragraphs: [
            '레이쥔은 1969년 후베이성 셴타오에서 태어났다. 부모 모두 평범한 교사였다. 1987년 우한대학 컴퓨터학과에 입학. 3학년이던 1989년 동급생들과 BBS 소프트웨어 클론으로 첫 창업을 시도. 1991년 22세에 진산(金山)의 추보쥔(求伯君)을 알게 되어 진산에 합류. 1998년 29세에 진산 CEO에 올랐다.',
            '진산에서의 16년 동안 그는 팀을 이끌고 WPS, 츠바, 두바, 검협정연 등을 출시했다 — 그러나 마이크로소프트와의 대결에서는 끝내 이기지 못했고, 진산은 줄곧 중국 소프트웨어 업계의 "2인자"였다.',
            '2007년 10월 9일 진산이 홍콩 거래소에 상장했다. 레이쥔은 건강상의 이유(과도한 스트레스로 인한 부정맥)로 CEO 자리를 내놓고 부회장으로 옮겼다. 38세, 경제적 자유를 얻고 반은퇴를 준비하고 있었다.',
            '이어진 3년(2007–2010), 그는 중국 초기 가장 활발한 엔젤투자자 중 한 명이 되었다. UC 브라우저, 판커청핀, YY, 둬칸, 커뉴, 러타오 등 십수 개 회사에 투자했다 — UC 한 건만으로도 회수가 30억 위안을 넘었다.',
            '하지만 40세를 앞두고 그는 초조해지기 시작했다.',
            '2010년 4월 6일 베이징 중관춘 인구 빌딩 807호. 레이쥔과 여섯 공동 창업자 — 린빈, 리완창, 저우광핑, 류더, 황장지, 훙펑 — 일곱 명이 한 테이블에 둘러앉았다. 레이쥔은 일곱 그릇의 좁쌀죽을 가져왔다. 각자 한 그릇씩 마시고, 일이 시작되었다.',
            '회사 이름은 "샤오미(小米)". "좁쌀과 소총" — 농촌이 도시를 포위한다는 인민해방군의 표현 — 의 의미와 함께, "좁쌀 한 알 단위"의 디테일에 집착한다는 제품 철학을 함께 담는다.',
          ],
          pullQuote: '"창업하지 않으면, 40세 이후의 나에게 어떻게 변명해야 할지 모르겠다."',
          paragraphsAfterQuote: [
            '엔젤투자자의 일은 "넓게 뿌려 확률을 잡는" 것이다. 2007–2010년의 레이쥔은 이미 중국에서 가장 돈을 잘 번 엔젤 가운데 하나였다. 그대로 갔다면 매년 누워서 십수억을 버는 것은 확정적이었다. 왜 그 안락한 삶을 포기했는가?',
            '인터뷰에서 레이쥔은 여러 번 말했다 — "나는 18년 프로그래머였고 16년 진산 CEO였다. 평생에서 가장 후회되는 것은 세계급 제품을 만들지 못한 것이다. 나는 빌 게이츠와 동시대를 살았고, 잡스와 동시대를 살았으며, 래리 페이지와 동시대를 살았다. 그러나 나는 Windows를 만들지 않았고, iPhone을 만들지 않았으며, Google을 만들지 않았다."',
            '그의 판단은 — **모바일 인터넷은 30년급의 창문이다**. iPhone은 2007년에 출시되었고 Android는 2008년에 오픈소스화되었으며, 2010년은 중국이 피처폰에서 스마트폰으로 전환하는 변곡점이었다. 이 파도를 놓치면 다음 기회는 20년을 기다려야 한다. **하드웨어 회사를 인터넷 방식으로 운영하는 일**은 중국만의 기회였다 — 중국에는 가장 완비된 전자 공급망(선전), 가장 큰 인구 기반, 가장 저렴한 유통 비용(인터넷 직판)이 있다.',
            '전부를 거는 것은, 계산이 끝났기 때문이다 — 엔젤은 분산할 수 있지만, 세계급 회사를 세우려면 올인밖에 없다. "제품을 만드는 사람은 이쪽도 저쪽도 동시에 할 수 없다."',
            '2011년 8월 16일, 샤오미 폰 1 발표. 1,999위안, 듀얼코어, 4인치 화면 — 같은 가격대의 모든 경쟁 제품을 능가하는 사양이었다. 첫 오픈 판매에서 30만 대가 몇 분 만에 매진되었다.',
            '2018년 7월 9일 샤오미가 홍콩에 상장되었다. 시가총액 540억 달러. 그날 연설에서 흘러나온 한 마디 — "바람이 맞으면 돼지도 난다."',
            '2024년 55세의 레이쥔은 EV "샤오미 SU7"을 발표한다 — 이것이 그의 두 번째 올인이었다. 샤오미는 다시 천억 달러대 시가총액으로 돌아왔고, 레이쥔은 중국 인터넷 새 세대의 "트래픽 정점"이 되었다.',
          ],
          checklist: {
            items: [
              '**경제적 자유는 종점이 아니라 다음 올인의 시작점이다**. 진짜 장기주의자는 항상 "다음으로 가장 중요한 일"에 올인한다.',
              '**엔젤투자와 창업은 양립할 수 없다**. 전자는 넓이, 후자는 깊이다. 레이쥔은 "투자자도 하면서 CEO도"가 아니었다 — 그는 투자자 정체성을 비웠다.',
              '**트랙을 보는 것보다 창문을 보는 게 더 중요하다**. 레이쥔이 스마트폰의 기회를 처음 본 사람은 아니다. 그러나 2010년 그 시점에 올인한 소수 중 한 명이었다.',
              '**40세의 창업이 늦지 않다, 단 올인이어야 한다**. 런정페이 43세, 레이쥔 41세, 왕싱 33세 — 전부를 밀어 넣을 때, 나이는 숫자에 불과하다.',
            ],
          },
        },

        {
          id: 'ch3-5',
          number: '05',
          title: '왕싱 · 천 그룹 전쟁의 막차 (2012)',
          paragraphs: [
            '1979년 푸젠성 룽옌 출생. 1996년 룽옌 1중에서 칭화대학 전자공학과로 진학. 2001년 칭화대 학부 졸업 후 미국 University of Delaware 박사과정에 진학. 박사를 절반쯤 마친 2003년 자퇴하고 귀국해 창업했다.',
            '왕싱의 처음 8년은 연속 실패의 8년이었다 —',
          ],
          list: {
            items: [
              '2003년, 둬둬유(Friendster 클론). 실패.',
              '2004년, 유쯔투(사진 공유). 실패.',
              '2005년, 샤오네이(校內網). 칭화·베이다에서 열풍, 2006년 천이저우에 200만 달러로 매각(이후 "런런왕"으로 개명).',
              '2007년, 판포우(Twitter 클론). 2009년 민감 콘텐츠로 503일간 폐쇄, 황금 창문을 놓침.',
              '2008년, 하이네이(기업판 Facebook). 실패.',
            ],
          },
          paragraphsAfterList: [
            '2010년 31세의 왕싱은 이미 8년 연속 창업, 4번의 명백한 실패. 실리콘밸리의 또래 친구들 다수가 백만장자가 되었을 때, 그는 여전히 급여를 위해 돈을 빌리고 있었다.',
            '2010년 3월 4일 왕싱은 메이퇀을 출시했다 — Groupon식 공동구매. 그러나 이번은 달랐다 — 2010–2011년 중국은 공동구매 광풍 한가운데였고, 정점에는 5,000개가 넘는 공동구매 사이트가 난립했다. 업계의 대본은 정해져 있었다 — 사용자 보조금, 도시 확장, 투자 유치, 다시 보조금, 다시 확장.',
            '왕싱은 그 대본을 거부했다.',
            '그는 세 가지 다른 일을 했다. **보조금 전쟁을 하지 않는다** — 모든 경쟁자가 "100위안 결제 50위안 할인"을 할 때, 메이퇀은 정가 + 가맹점 서비스 품질로 승부했다. **IT 시스템에 집중 투자한다** — 다른 모두가 지상 영업, 광고, 사용자 보조금에 돈을 쓸 때, 메이퇀은 예산의 절반을 플랫폼 시스템 능력을 다듬는 데 썼다. **가계부 사고** — 새 도시를 열 수 있는지는 ROI 모델에 달려 있다. 모델이 통하지 않으면 열지 않는다.',
            '2011년 하반기, 자본 시장의 공동구매 모델 평가는 광기에서 의심으로 뒤집혔다. VC의 지갑이 닫혔다. 2011년 말 자금을 조달하지 못한 공동구매 사이트들이 무너지기 시작했다. 2012년은 업계에서 가장 참혹한 해였다.',
          ],
          pullQuote: '"실패를 거부하면, 성공도 거부하는 것이다."',
          paragraphsAfterQuote: [
            '그해 사내 서한에서 왕싱은 썼다 — "우리는 천 그룹 전쟁을 살아남았다. 그러나 전쟁은 끝이 아니라 시작이다." 그해 메이퇀은 대규모 정리 해고도, 도시 철수도 하지 않았다. 오히려 배달(외매) 사업으로 진출하기 시작했다 — 그가 건 다음 올인 지점이었다.',
            '왕싱의 올인은 "공동구매에 전부를 거는 것"이 아니라 "10년을 달릴 서비스 회사에 전부를 거는 것"이었다. 자금이 빠듯한 2011–2012년에 그는 반직관적인 결정을 내렸다 — **운영 현금 두 달 치를 남기고, 나머지는 모두 팀과 시스템에 투입한다**.',
            '경쟁자들의 방식 — 통장에 6개월 치 현금이 있다, 5개월간 보조금을 태워 사용자를 모으고 남은 1개월에 다시 자금을 조달한다. 못 받으면 회사는 죽는다.',
            '왕싱의 방식 — 통장에 6개월 치가 있다, 2개월을 생존용으로 남기고 4개월간 사람을 뽑고 시스템을 만들고 기반을 다진다. 자금 조달이 실패해도 회사는 두 달을 더 살 수 있다 — 그 두 달 동안 계속 제품과 서비스를 다듬으며 다음 라운드의 기회를 기다린다.',
            '이런 계산은 보수적으로 들리지만, 본질은 또 다른 형태의 올인이다 — **"장기주의"라는 판단에 올인하는 것**.',
            '2013년 메이퇀이 배달에 진출. 2015년 10월 다중뎬핑(大眾點評)과 합병. 2017년 차량 호출에 진입. 2018년 9월 20일 홍콩에 상장 — 시가총액 4,000억 홍콩달러. 2020년 팬데믹으로 배달 침투율이 급등하면서 시가총액은 정점에서 2,000억 달러를 넘었다.',
          ],
          checklist: {
            items: [
              '**9패 1승** — 한 번만 이길 수 있다면 끝까지 이겨야 한다.',
              '**현금은 쓰는 것이 아니라 버티는 것이다**. 전장이 보이기 전까지는, 전장이 "보일 만큼" 버틸 수 있는 현금 버퍼를 남겨둬라.',
              '**상대의 잘하는 게임에 끌려가지 마라**. 모두가 돈을 태울 때 너는 차분히 제품을 만들어라. 모두가 제품을 만들 때 너는 차분히 채널을 밀어라. 항상 "상대가 가장 약한 차원"에서 올인하라.',
              '**장기주의 자체가 하나의 베팅이다**. 왕싱이 건 것은 "공동구매가 이긴다"가 아니라 "10년 단위로 일하는 사람이 이긴다"였다.',
            ],
          },
        },

        {
          id: 'ch3-6',
          number: '06',
          title: 'CZ · 집을 팔아 비트코인에 올인 (2014)',
          paragraphs: [
            '자오창펑(CZ)은 1977년 장쑤성 롄윈강에서 태어났다. 아버지는 대학 교사였는데, 정치적 이유로 외딴 지역으로 보내졌고, 1989년 가족 모두 캐나다 밴쿠버로 이민했다.',
            '캐나다에서의 청소년기, CZ는 맥도날드 아르바이트, 주유소 야간 근무, 도쿄 스시집의 견습 — 전형적인 "가난한 이민 2세"의 길을 걸었다. 1996년 맥길대학 컴퓨터학과에 입학. 졸업 후 블룸버그(Bloomberg)에 입사해 거래 시스템 엔지니어가 되었다. 2005년 블룸버그를 떠나 창업했다 — 고빈도 거래 시스템 Fusion Systems, 고객은 월스트리트의 헤지펀드들이었다.',
            '2013년 어느 날, CZ는 친구와 저녁을 먹었다. 그 친구는 식사 내내 비트코인 이야기를 했다. CZ의 당시 반응 — 전혀 이해되지 않았다.',
            '그러나 며칠 뒤 그는 비트코인 백서를 읽었다. 며칠 더 지나 안드레아스 안토노풀로스의 〈Mastering Bitcoin〉을 다 읽었다. 몇 주 더 지나 그는 상하이로 날아가 OKCoin(쉬밍싱의)을 찾아가 합류하고 싶다고 말했다.',
            '2014년 CZ는 상하이에 아파트 한 채를 가지고 있었다(구체적인 위치는 공개하지 않았으나 시내 중심부로 추정). 그는 그것을 팔았다. 모든 자금을 비트코인으로 바꿨다.',
            '2014년의 비트코인 가격은 200–700달러 사이를 오갔다(연초 800, 연중 600, 연말 320). CZ는 매수 평균가를 공개하지 않았지만, 2014년의 중간값으로 추정하면 1,000–3,000 BTC쯤 매수한 것으로 보인다.',
            '이 일은 2014년 당시 거의 알려지지 않았다. 2018년 인터뷰에서 "가장 올인했던 결정은?"이라는 질문에 그는 답했다 — "2014년에 상하이의 집을 팔아 전부 비트코인을 샀다."',
          ],
          pullQuote: '"내가 건 것은 비트코인이 오른다는 것이 아니다. 내가 건 것은 — 암호화폐가 금융 인프라를 바꾼다는 일이, 반드시 일어난다는 한 가지였다."',
          paragraphsAfterQuote: [
            '"5년이 걸릴 수도, 10년이 걸릴 수도, 20년이 걸릴 수도 있다. 그러나 반드시 일어난다. 일어난다면 비트코인이 새 세계에서 가장 확실한 자산이다. 일어나지 않으면, 집 한 채를 기부했다고 치겠다."',
            '그때 그는 이미 OKCoin에서 일하고 있었고, 2015년에는 Blockchain.info로 옮겼다. 그는 코인을 굴리는 사람이 아니었다 — 인프라를 짓는 사람이었다.',
            '2017년 5월 CZ는 OKCoin을 떠났다. 6월 26일 바이낸스(Binance) ICO 시작, 1,500만 달러 조달. 7월 14일 바이낸스 거래소 정식 가동. 직원 11명. 단순한 웹사이트. 단순한 약속 — 낮은 수수료, 다양한 통화 페어, 기술적 안정.',
            '2017년 9월 4일 중국 7개 부처가 〈토큰 발행 자금조달 위험 방지에 관한 공고〉를 공동 발표하며 ICO와 암호화폐 거래소를 전면 금지했다. 가동 두 달의 바이낸스가 생사의 갈림길에 놓였다.',
            'CZ의 반응 — 그날 밤 일본으로 이주했다. 사흘 만에 팀 전체를 도쿄, 홍콩, 몰타, 싱가포르로 분산시켰다. 바이낸스는 "무국적" 회사가 되었다. 2017년 말 바이낸스의 DAU는 600만을 넘어, 세계 최대 암호화폐 거래소가 되었다. 가동에서 1위까지 180일도 걸리지 않았다.',
            '2014년의 집 매각과 2017년의 바이낸스 창업은 같은 사고의 두 번의 실행이다. **"인프라"에 걸지 "가격"에 걸지 않는다** — CZ는 비트코인이 10만 달러로 간다고 한 번도 말하지 않았다. 그는 "암호화폐 금융 인프라는 반드시 만들어진다"라고만 말했다. **모두가 규제를 두려워할 때 규제 차익에 올인한다** — 2017년 중국 금지령은 바이낸스의 가장 큰 위협이 아니라 가장 큰 기회였다. **"무국적"을 경쟁력으로 만든다** — 바이낸스는 첫날부터 8개국의 직원, 4개 언어 고객 지원, 30개 이상의 법정통화 입금 채널을 갖췄다.',
            '2022년 11월 8일 FTX 붕괴. CZ는 구제를 거부하며 SBF의 추락을 가속화했다. 바이낸스는 그 기세를 타고 시장을 더 가져왔다. 2023년 11월 21일 미국 법무부가 바이낸스와 CZ의 유죄 인정, 43억 달러의 벌금을 발표. CZ는 CEO직을 내려놓고 4개월 복역. 2024년 4월 출소, 하반기에 다시 활발해졌고, 바이낸스는 여전히 세계 최대의 거래소다.',
          ],
          checklist: {
            items: [
              '**집을 판 사람은 돌아오지 않는다**. CZ는 2014년 매각 이후 "언젠가 빠지고 싶을 때 돌아갈 수 있는" 퇴로를 잃었다 — 자기 자신을 잠가버렸다. 이 자물쇠가 종종 가장 큰 실행력의 원천이다.',
              '**장기 서사에 베팅하지 단기 가격에 베팅하지 마라**. 비트코인은 2014년부터 2024년까지 100배가 되었다. 그러나 CZ가 "10배 오르면 판다"는 목적으로 샀다면 진작에 빠져나갔을 것이다. "팔지 않는다"로 사는 것이 진짜 올인이다.',
              '**규제는 위협이 아니라 기회다**. 큰 규제 사건마다 "반신반의"하던 플레이어들이 빠져나가고, "완전히 믿는" 사람들이 시장 전체를 가져간다.',
              '**인프라 > 자산 가격**. CZ는 BTC가 얼마나 오르는지에 걸지 않았다. 그는 "암호화폐 거래소"라는 인프라의 자리에 걸었다. 결과는 BTC 100배, 바이낸스 1,000배.',
            ],
          },
        },

        {
          id: 'ch3-7',
          number: '07',
          title: '콜린 황 · 세 번의 재시작 (2015)',
          paragraphs: [
            '1980년 저장성 항저우 출생. 부모 모두 평범한 노동자. 어릴 때부터 성적이 좋았고, 1998년 추천으로 항저우외국어학교(항외)에 들어갔다. 그곳에서 그의 인생을 바꾸는 한 사람을 만난다 — 돤융핑. 두 사람은 학내 행사를 통해 알게 되었다. 당시 돤융핑은 이미 BBK의 사장이었고, 모교에 손님으로 와 있었다.',
            '2002년 저장대학 컴퓨터학과 학부 졸업. 콜린 황(黃崢)은 돤융핑의 후원으로 University of Wisconsin–Madison 컴퓨터 석사 과정에 진학. 2004년 석사 졸업 후 구글 차이나 초기 팀에 합류했다.',
            '2006년 구글에서 버핏 점심 경매에 참여한 돤융핑이 62만 달러로 자리를 낙찰받고, 콜린을 데리고 가서 버핏과 멍거를 만났다 — 콜린의 비즈니스 인생에서 가장 중요한 한 번의 수업이었다.',
            '2007년 27세에 콜린은 구글을 떠나 첫 창업 — 어우쿠왕(歐酷網). 2009년 4,500만 달러에 란팅콜렉션(蘭亭集勢)에 매각. 2009년 두 번째 창업 — 러치 운영 대행사: P&G와 유니레버 등의 전자상거래를 대행. 2013년 세 번째 창업 — 쉰멍(尋夢) 게임.',
            '2015년 35세의 콜린은 이미 세 회사를 세웠다 — 어우쿠(매각), 러치(흑자 운영), 쉰멍(흑자 운영). 손에 돈, 팀, 자원이 있었다. 세 회사를 그대로 굴렸으면 평생 의식주 걱정이 없었다. 그러나 그는 네 번째 재시작을 했다.',
            '2015년 9월 콜린은 동시에 두 개의 새 프로젝트를 부화시켰다 — 핀하오훠(생활용품 EC)와 핀둬둬(잡화 EC). 2016년 9월 두 회사를 합병해 "핀둬둬(拼多多)"가 되었다.',
            '왜 공동구매인가, 왜 하층 시장인가?',
            '2015년의 중국 EC는 이미 양강 체제 — 징둥 + 알리바바. 시장은 EC 업계에서 더 이상 창업 기회가 없다고 여겼다. 콜린이 본 것은 달랐다 — "징둥과 알리바바가 상대하는 것은 중국의 도시 인구 5억이다. 또 다른 5억의 농촌, 3·4선 도시 인구는 그 누구도 제대로 대응하지 않는다."',
          ],
          pullQuote: '"상식을 유지하고, 소란에서 멀어진다."',
          paragraphsAfterQuote: [
            '핀둬둬의 설계 — **공동구매** — 소셜 관계로 바이럴, 획득 비용을 극한까지 낮춘다. **WeChat 생태계** — 독립 앱을 만들지 않고 WeChat 내에 기생한다. **노브랜드 상품** — 브랜드를 팔지 않고 공장 직판을 판다, 가격은 징둥/타오바오의 절반. **알고리즘 분배** — 검색이 아니라 추천, 사용자가 상품을 "스와이프"하게 한다.',
            '이 모든 선택은 동종 업계에 비웃음당했다. "핀시시(가짜)", "위조품", "수준 떨어진다" — 핀둬둬는 3년간 욕을 들었다. 그러나 사용자는 늘었다. 2017년 핀둬둬의 연 GMV가 1,000억 위안을 돌파.',
            '콜린의 올인은 "비즈니스 상식"을 비웃음 받는 방향으로 전부 밀어 넣은 것이었다. **주류 시장에 걸지 않는다** — 모두가 베이상광선의 엘리트 사용자를 노릴 때, 그는 5환 밖의 인구에 걸었다. **반앱 사고** — 모든 EC가 독립 앱을 만들 때, 그는 WeChat 생태에 걸었다. **반브랜드 사고** — 모든 EC가 "소비 업그레이드"를 말할 때, 그는 "소비 다운그레이드"에 걸었다. **반검색 사고** — 모두가 검색창으로 분배할 때, 그는 알고리즘 추천에 걸었다.',
            '한 줄 한 줄이 반주류였다. 한 줄 한 줄이 "인터넷 원주민이 아닌 사람들"에 대한 깊은 통찰에 기반했다.',
            '게다가 그에게는 "돤융핑 → 버핏 → 멍거"의 세 층의 스승이 있었다. 세 사람이 그에게 함께 가르친 한 가지 — **너의 논리가 주류와 반대일 때, 먼저 "내가 무엇을 잘못 봤나"를 물어라. 묻고도 원래 판단을 유지한다면, 올인하라**.',
            '2018년 7월 26일 핀둬둬가 나스닥에 상장, 시가총액 240억 달러. 그날 콜린은 38세였다. 2020–2021 핀둬둬의 GMV가 한때 징둥을 뛰어넘었다. 2024년 핀둬둬의 시가총액 정점은 2,200억 달러를 넘었고, 해외 브랜드 Temu는 미국에서 아마존을 위협한다.',
            '2021년 3월 41세의 콜린이 CEO 사임을 발표하고 과학 연구로 옮겼다 — 생명과학과 식품과학에 투입. 공개 서한에서 그는 말했다 — "나는 지쳤다. 남은 인생은 진짜 호기심이 가는 일에 쓰고 싶다."',
          ],
          checklist: {
            items: [
              '**재시작은 부끄러운 일이 아니다**. 35세의 콜린은 이미 세 회사를 세웠지만 "경로 의존 속에서 계속하는" 길을 택하지 않았다. 매번 그는 자문했다 — "이게 10년 뒤에도 하고 싶은 일인가?"',
              '**반주류 판단은 더 깊은 연구를 요구한다**. 결론이 모든 사람과 다르다면, 다른 이가 못 본 무언가를 봤거나 잘못 본 것이다. "내가 어디에서 틀렸을 수 있는가"를 여러 번 자문하라.',
              '**스승의 복리**. 돤융핑 → 버핏 → 멍거, 세 층의 스승이 가치투자의 세계관을 콜린에게 완전하게 전달했다. 중요한 결단의 순간에, 다른 사람의 50년 지혜를 빌릴 수 있다.',
              '**나가는 것이 들어가는 것보다 어렵다**. 41세의 콜린이 은퇴해 과학 연구로 간 일은, 또 다른 의미의 올인이다 — 인생 후반을, 즉시 보상이 오지 않을 일에 올인했다.',
            ],
          },
        },

        {
          id: 'ch3-8',
          number: '08',
          title: '장이밍 · 틱톡 해외 진출 (2016)',
          paragraphs: [
            '1983년 푸젠성 룽옌 출생. 왕싱과 같은 룽옌 출신이며, 둘 다 룽옌 1중 졸업. 아버지는 기관 간부, 어머니는 간호사.',
            '2001년 난카이대학 마이크로일렉트로닉스 전공으로 입학, 소프트웨어에 더 흥미를 느껴 2003년 소프트웨어 공학으로 전과. 난카이 시절 컴퓨터 고전을 거의 다 읽었고 오픈소스 프로젝트에 코드를 기여하기 시작했다.',
            '2005년 졸업. 2005–2009년 사이 여러 회사를 거쳤다 — IBM 인턴(지루해서 사직), 쿠쉰(酷訊) 여행 검색(1년 만에 엔지니어에서 기술 책임자로), 판포우(왕싱의 두 번째 회사), 99방(자기 창업).',
            '2011년 28세의 장이밍은 이미 4개 회사, 3번의 명백한 실패를 경험했다. 그는 한 가지 질문을 곱씹고 있었다 — **왜 인터넷 업계의 모든 콘텐츠 분배는 여전히 편집자 추천인가?**',
            '2012년 3월 9일 바이트댄스(ByteDance) 설립. 같은 해 8월 진르터우탸오(今日頭條) 1.0 출시.',
            '진르터우탸오의 핵심 혁신 — **알고리즘 추천이지, 편집자 추천이 아니다**. 이는 2012년의 중국에서는 이단이었다. 당시 모든 콘텐츠 플랫폼 — 시나, 왕이, 소후, 텐센트 — 은 편집자가 기사를 고르고, 메인에 올리며, 사용자는 수동적으로 받았다. 알고리즘 추천은 "저급", "낚시 제목의 온상", "기계는 콘텐츠를 이해할 수 없다"고 여겨졌다.',
            '장이밍의 판단 — 알고리즘 + 데이터 = 편집자보다 사용자를 더 잘 안다.',
            '하지만 처음 두 해는 순탄치 않았다. 2012–2013년 터우탸오의 성장은 더뎠고, 자금 조달은 수십 번 거절당했다(대다수 VC가 알고리즘 추천이 주류가 될 수 있다고 믿지 않았다). 2014년 6월 세쿼이아가 터우탸오 C 라운드에 5억 달러 평가로 들어와, 알고리즘 노선의 첫 번째 큰 베팅 주체가 되었다. 2014–2016년은 터우탸오의 폭발기. MAU가 1,000만에서 1억 5천만으로 늘었다.',
            '2016년 9월 바이트댄스가 짧은 동영상 앱을 출시, 이름을 "더우인(抖音)"으로 바꿨다. 2017년 더우인의 DAU가 5,000만을 돌파, 2018년에는 2억을 돌파.',
            '하지만 더 결정적인 결단은 해외 진출이었다.',
            '2017년 11월 바이트댄스가 10억 달러로 Musical.ly를 인수. 2018년 8월 Musical.ly와 해외판 더우인을 합쳐 TikTok으로 만들었다.',
            '그때 바이트댄스의 보유 현금은 30억 달러를 넘지 않았다. 10억 달러 인수는 통장의 1/3을, 누구도 성공을 확신하지 못한 일에 거는 것이었다 — 중국 앱이 구미 C 시장에 진출해 성공한 적이 한 번도 없었기 때문이다(WeChat과 QQ도 해외에서 실패했다).',
            '장이밍은 그 뒤 5년 동안 바이트댄스의 자원과 인재 70%를 TikTok에 기울였다.',
          ],
          pullQuote: '"만족 유예는, 인생을 무한 게임으로 플레이하는 능력이다."',
          paragraphsAfterQuote: [
            '장이밍의 "만족 유예" 철학은 해외 진출에서 가장 선명하게 드러났다. 2016–2017년의 중국 인터넷에서는 모두가 "BAT 외의 국내 보너스"를 잡으려 달리고 있었다. 그러나 장이밍의 판단은 —',
            '첫째, **국내 시장의 천장이 충분히 높지 않다**. 진르터우탸오가 이미 중국에서 1.5억 MAU에 도달했고, 더 오를 공간이 한정적이었다.',
            '둘째, **알고리즘 + 짧은 동영상 + 추천 피드는 보편적인 콘텐츠 제품이다**. 이 조합은 중국의 특수성에 의존하지 않으며, 이론상 전 세계에 서비스할 수 있다.',
            '셋째, **C 시장에서 진정으로 구미를 뚫은 중국 인터넷 회사는 단 하나도 없다**. 누군가 해낼 수 있다면, 그것이 이 세대 최대의 보너스가 된다.',
            '넷째, **해외 진출이 거는 것은 시장 점유율이 아니라 발언권이다**. 미국 시장에서 1억 사용자를 가진 중국 회사는, 새 냉전 시대의 "소프트 파워 무기"와 같다.',
            '70%의 자원을 불확실한 일에 거는 것은, "만족 유예"를 믿는 사람만이 할 수 있다.',
            '2019년 TikTok의 미국 DAU가 4,000만을 돌파. 2020년 트럼프가 TikTok 금지를 시도했으나 실패. 2021년 TikTok 글로벌 MAU가 10억을 돌파. 2024년 바이트댄스의 평가액은 약 3,000–5,000억 달러(프라이빗 시장).',
            '2021년 5월 20일 38세의 장이밍이 CEO 사임을 발표, 량루보가 뒤를 이었다. 사내 서한에서 그는 — "일상 경영을 내려놓고, 5–10년 단위의 일을 생각하고 싶다."',
          ],
          checklist: {
            items: [
              '**알고리즘은 이 시대 가장 과소평가된 인류의 발명이다**. 2012년 장이밍의 판단 "알고리즘 + 콘텐츠가 분배권을 재구성한다"는, 10년 뒤 조 단위 가치의 판단이 되었다.',
              '**만족 유예는 베팅하지 않는 게 아니라 크게 베팅하는 것이다**. "기다리는" 듯 보이는 사람일수록, 때가 무르익었을 때 다른 이가 상상도 못 한 크기로 베팅한다.',
              '**국제화는 매출 확장이 아니라 제품 유전자다**. 첫날부터 전 세계를 위해 설계된 제품이, 10년 뒤 전 세계를 가져간다. 중국 시장에서 시작한 뒤 해외를 고민한 제품은 거의 다 문화 장벽에서 멈춘다.',
              '**반합의를 세 번 이상 한 사람만이 큰일을 이룬다**. 알고리즘 추천이 2012년 합의에 거스르고, 더우인이 2016년 짧은 동영상 합의에 거스르고, 해외 진출이 2017년 중국 인터넷 합의에 거슬렀다. 매번 맞았다.',
            ],
          },
        },

        {
          id: 'ch3-9',
          number: '09',
          title: '저스틴 선 · 카메라 앞의 올인 (2017)',
          paragraphs: [
            '1990년 칭하이성 시닝 출생. 아버지는 중학교 어문(국어) 교사. 고등학교 때부터 글을 쓰기 시작했고 2007년 신개념 작문 1등상을 수상. 2008년 베이징대 사학과에 입학. 2013년 베이징대 학부 졸업 후 미국 펜실베이니아대학교 석사 과정에 진학.',
            '2013년 리플(Ripple)에 합류해 중화권 대표를 맡았다. 2년 뒤 떠나 독립.',
            '2017년 8월 28일 27세의 저스틴 선(孫宇晨)은 트론(TRON) ICO를 시작해 7,000만 달러를 모았다. 2017년 9월 4일 중국 7개 부처가 〈토큰 발행 자금조달 위험 방지에 관한 공고〉를 공동 발표. 모든 ICO 프로젝트가 자금 조달 중단과 환불을 요구받았다. 트론은 그 한가운데에 있었다. 외부의 시각은 일치했다 — 트론은 죽었다.',
            '그러나 저스틴 선은 전통적 노선을 택하지 않았다. 그는 카메라 앞에서 — 여러 차례의 라이브 방송, 여러 차례의 인터뷰에서 — 분명히 입장을 밝혔다 — "All In! 내 개인 전 자산이 트론에 있다."',
            '이건 마케팅 화술이 아니었다. 하나의 자세였다 — 자기 퇴로를 완전히 태워버리고, 망설일 만한 모든 투자자와 홀더에게 보여주는 것이다 — "나에겐 plan B가 없다."',
            '2018년 6월 25일 TRON 메인넷이 정식 가동. 같은 해 7월 TRON이 BitTorrent를 인수(1억 4천만 달러), 암호화폐 업계 최초의 대형 M&A.',
            '2018년 말 트론은 이미 글로벌 톱 10의 퍼블릭 체인이 되었고, TRX 유통 시가총액의 정점은 100억 달러를 넘겼다.',
          ],
          pullQuote: '"All In!"',
          paragraphsAfterQuote: [
            '저스틴 선의 올인은 논쟁적이다 — 업계 평가는 양극으로 갈린다. 그러나 논쟁을 제쳐두고 결단만 보면, 그의 "All In!" 자세 자체가 몇 가지를 바꿔놓았다.',
            '첫째, **"올인"이라는 단어를 중국어 암호화폐 문맥에 굳혀 놓았다**. 그 이전 중국어권의 대응어는 "梭哈"나 "重倉"이었지만 어느 쪽도 슬로건성이 부족했다. 그가 카메라 앞에서 "All In!"을 외친 후, 이 두 단어의 영문은 문화적 상징이 되었다.',
            '둘째, **"개인 All In"이 "팀 All In"을 대체했다**. 전통적 창업 프로젝트는 팀의 신용에 기반했지만 트론은 저스틴 선 개인의 신용에 기반했다. 그의 베팅은 — 나를 믿는다면 TRX를 들어라, 안 믿는다면 떠나라. 이 급진적 "개인화된 약속"은 이후 많은 meme 코인과 암호 KOL 프로젝트의 템플릿이 되었다.',
            '셋째, **규제 압박기에 역방향으로 움직인다**. 2017년 9월 금지령 이후 합리적 반응은 시장 철수, 전환, 축소였다. 저스틴 선의 반응은 — 해외 이주, 투입 강화, 노출 배가. 이 "역방향 All In"은 2008년 머스크가 네 번째 발사에 건 것과 같은 논리다 — 다른 사람들이 후퇴할 때, 너는 올인한다.',
            '2019년 6월 저스틴 선은 457만 달러로 "버핏 점심"을 낙찰받았다 — 사상 최고가. 건강상의 이유로 미뤄졌다가 2022년 5월에 성사되었다.',
            '2020–2021 암호화폐 강세장에서 TRX는 큰 폭으로 올랐고, 트론은 USDT의 주요 발행 체인이 되었다(정점에 TRC20-USDT 유통량이 500억 달러를 넘었다). 그러나 논쟁은 계속됐다. 2023년 SEC가 저스틴 선을 시장 조작 혐의로 제소. 2022년에는 알고리즘 스테이블코인 USDD의 디페그 위기.',
            '2024–2025년 시점에 TRX는 여전히 글로벌 톱 10 토큰 중 하나이고, 저스틴 선은 여전히 암호화폐 업계에서 가장 화제성 있는 중국인 창업자다.',
          ],
          checklist: {
            items: [
              '**공개적으로 All In하는 것은 자기 결박형 약속이다**. 카메라 앞에서 "내 전 자산이 여기 있다"고 입에 올리는 순간, 너는 자신에게 되돌릴 수 없는 약속을 부과한다. 그 결박 자체가 실행력이다.',
              '**문화적 상징으로서의 "올인"의 힘**. 한 단어, 한 슬로건, 하나의 자세가, 때로 비즈니스 모델보다 더 합의를 모은다.',
              '**논쟁 + 올인은 공존한다**. 모든 것을 거는 사람은 반드시 논쟁을 동반한다. 한 번도 비난받지 않은 창업자라면, 진짜로 전부를 걸지 않았기 때문일 수 있다.',
              '**역방향 행동이 올인의 기본 자세다**. 규제 금지령, 시장 패닉, 여론의 포위 — 이런 순간이 오히려 올인의 가장 좋은 창문이다.',
            ],
          },
        },
      ],
      paragraphsTail: [
        '아홉 개의 이야기를 다 말했다.',
        '수록되어야 할 모든 사람을 다 담은 것은 아니다. 이 권은 시작이다 — 앞으로 커뮤니티 투고에서 채택된 모든 이야기가 이 명단의 연장선을 써 나갈 것이다.',
        '주변에 그런 사람이 있다면, 또는 당신 자신이 그런 사람이라면 — 투고하라.',
        '긴 명단은 이제 막 시작되었다.',
      ],
    },

    {
      id: 'ch4',
      kind: 'chapter',
      number: 'IV',
      title: '커뮤니티 공동 구축',
      paragraphs: [
        'ALLIN은 한 사람이 다 쓸 수 있는 프로젝트가 아니다. 이 장에서 명확히 한다 — 어떻게 기여하고, 어떻게 수록하고, 보상은 어떻게 분배하는가.',
      ],
      subsections: [
        {
          id: 'ch4-1',
          number: 'i',
          title: '누가 투고할 수 있는가',
          paragraphs: [
            '누구든 올인 이야기를 투고할 수 있다.',
            '받아들이는 세 가지 출처:',
          ],
          checklist: {
            items: [
              '**개인의 이야기** — 당신이 직접 겪은 올인의 순간',
              '**목격자의 대필** — 가까운 이가 겪은, 당신이 대신 써 주고 싶은 이야기',
              '**연구형 투고** — 당신이 연구한 공인의 올인 순간. 인용은 원전까지 추적 가능해야 한다',
            ],
          },
          paragraphsTail: [
            '세 번째가 현재 〈올인의 인물전〉의 주된 출처다. 첫 번째는 빠르게 늘고 있다 — 이미 수십 건의 익명 투고를 받았고 심사 중이다.',
          ],
        },
        {
          id: 'ch4-2',
          number: 'ii',
          title: '채택 기준',
          paragraphs: [
            '모든 "All in"이 올인은 아니다. 채택 기준은 엄격하다. 한 이야기가 수록되려면 아래 세 조건을 **모두** 충족해야 한다 —',
          ],
          checklist: {
            items: [
              '**조건 1 · 반드시 "잃어도 견딜 수 있는 전부"를 걸었어야 한다** — 10%는 올인이 아니다, 50%도 아니다. "실패하면 즉시 실질적 곤경에 빠지는" 수준이어야 한다 — 집을 판다, 통장을 비운다, 자산을 담보로 잡는다, 안정 수입을 포기한다, 모든 대안을 끊는다. 구체적인 자산 수치, 끊긴 수입, 닫힌 퇴로가 보여야 한다.',
              '**조건 2 · 명확한 결단의 순간이 있어야 한다** — "10년 동안 그 일을 했다"는 올인이 아니다. 구체적인 순간이 보여야 한다 — 어느 날, 어떤 회의, 한 마디, 어떤 서명 — 결정이 내려진 그 순간. "아침에 죽을 마신 그 순간"일 수도 있고, "저녁에 계약서에 서명한 그 순간"일 수도 있다. 그러나 반드시 타임스탬프여야 한다.',
              '**조건 3 · 검증 가능한 결과가 있어야 한다** — 성공이든 실패든 공개적으로 확인 가능한 "그 후"가 있어야 한다 — 제품이 출시됐다, 회사가 망했다, 시가총액이 변했다, 자금 흐름이 변했다. 실패의 이야기도 성공만큼이나 가치가 있다. 단, 실패 그 자체가 정직하게 기록될 수 있어야 한다.',
            ],
          },
          paragraphsTail: [
            '셋 중 하나도 빠질 수 없다.',
            '우리는 "실패한 올인"도 수록한다 — 이런 이야기는 묻혀서는 안 된다. 모든 것을 걸고 진 사람은, 모든 것을 걸고 이긴 사람과 같은 무게의 용기를 진다.',
          ],
        },
        {
          id: 'ch4-3',
          number: 'iii',
          title: '투고 절차와 보상',
          paragraphs: [
            '한국어로 3,000–4,000자의 이야기를 "배경 / 결정적 순간 / 결단의 논리 / 그 후 / 교훈"의 다섯 단락 구조로 작성한다. 최소 3개의 공개 출처를 인용한다(개인 이야기는 당사자의 진술 + 타임스탬프 가능. 공인은 뉴스, 연차보고서, 평전 등 검증 가능한 자료가 필요). Telegram(@allin_submissions) 또는 GitHub PR(allin/manifesto repo)로 투고. 커뮤니티 익명 심사, 보통 2–4주 안에 회신.',
            '커뮤니티 풀은 토큰 총량의 10%로, 컨트랙트 확인 후 별도 주소에 잠긴다. 분배 방식 —',
          ],
          checklist: {
            items: [
              '수록된 이야기마다 저자에게 고정 30만 ALLIN 기본 보상',
              '인용 / 전송 / 번역이 1,000회마다, 저자에게 추가 5만 ALLIN',
              '번역자(중→영, 중→기타 언어)는 원저자 보상의 30%',
              '최초 100편의 수록 이야기 저자에게는 "창세 기여자" 온체인 NFT 배지를 영구히 부여',
            ],
          },
          paragraphsTail: [
            '솔직히 말한다 — 금액은 핵심이 아니다. 이 선언에 수록되는 것, 온체인에 영구히 기록되는 것, 모든 미래의 ALLIN 홀더에게 읽히는 것 — 이것이 핵심 동기다.',
            '거버넌스에 관해 — ALLIN은 DAO가 아니며, "토큰 투표로 로드맵을 정하는" 식의 쇼는 하지 않는다. 그러나 다음은 한다. 채택 기준의 개정은 코어 커뮤니티 기여자의 집단 토론으로. 중대한 결정(예: 향후 자금 조달, CEX 상장 여부)은 커뮤니티 서명 공시로. 토큰 분배의 집행은 매월 온체인 공개 기록으로. 선언문 수정 제안은 14일의 공시 기간을 거쳐야 한다.',
          ],
          pullQuote: '약속은 적게, 했으면 반드시 지킨다.',
        },
      ],
    },

    {
      id: 'ch5',
      kind: 'chapter',
      number: 'V',
      title: '메커니즘과 투명성',
      paragraphs: [
        '이 장은 본래 길게 쓸 수 있다 — 체인, 컨트랙트, 분배, 보안 감사, 유동성 증명을 모두 펼쳐서. 그러나 우리는 짧게 쓰기로 했다.',
        '이 모든 것은 온체인을 한 번 조회하면 다 보이기 때문이다. 글로 다시 묘사할 필요가 없다.',
      ],
      subsections: [
        {
          id: 'ch5-1',
          number: 'i',
          title: '기본 정보',
          checklist: {
            items: [
              '**체인** · BNB Chain (BSC)',
              '**컨트랙트 주소** · 0x234c3bFC260277cb4497E498A83aB685E30Ac730',
              '**토큰 표준** · BEP-20',
              '**총 발행량** · 1,000,000,000 ALLIN',
              '**소수점 자리** · 18',
              '**DEX** · PancakeSwap V2',
              '**거래 페어** · ALLIN/USDT, pair address 0xa6c24770d62b156115198de3fcc9be9e70bf975e',
              '**시세 데이터** · DexScreener / GeckoTerminal / CMC (순차 등재)',
            ],
          },
        },
        {
          id: 'ch5-2',
          number: 'ii',
          title: '토큰 분배',
          paragraphs: [
            '**공개 유동성 85%** — 가동 즉시 PancakeSwap에 주입, LP는 영구 소각. 온체인에서 증명 가능한 소각 트랜잭션은 컨트랙트 생성 후 24시간 안에 실행.',
            '**커뮤니티 인센티브 10%** — 〈올인의 인물전〉 투고 보상, 번역 보상, 커뮤니티 기여 포상에 사용. 주소는 공개되며, 매월 온체인에 지출이 기록된다.',
            '**마케팅 5%** — KOL, 미디어, 커뮤니티 행사에 사용. 주소 공개, 모든 지출은 24시간 이내 트위터에 공시.',
            '**팀 보유 0%** — 없다. 우리는 챙기지 않는다.',
          ],
        },
        {
          id: 'ch5-3',
          number: 'iii',
          title: 'LP 소각과 라이브 대시보드',
          paragraphs: [
            'LP 소각의 트랜잭션 hash는 온체인에서 조회 가능하다. 이것이 이 프로젝트에서 가장 중요한 트랜잭션이다 — "풀을 빼낼" 능력이 우리에게 없음을 증명한다. 누구나 BscScan에서 검증할 수 있다 — 컨트랙트 생성 → 유동성 추가 → LP 토큰을 0x000…dead 주소로 전송.',
            '기술 세부가 어렵다면, 한 가지만 기억하면 된다 — **LP 소각 이후 이 토큰의 풀은 영원히 운영 측이 빼낼 수 없다, 누구도 빼낼 수 없다**.',
            '홈페이지의 네 개의 라이브 데이터 카드 — 시가총액, 홀더 수, 24h 거래량, 풀 USDT — 는 DexScreener API + GoPlus Security API에서 가져오며, 60초마다 자동 갱신된다. 브라우저 개발자 도구로 요청을 검증할 수 있다. 이상이 발견되면 Telegram으로 신고해 주기 바란다.',
          ],
        },
        {
          id: 'ch5-4',
          number: 'iv',
          title: '우리에게 없는 것',
          paragraphs: [
            '이 토큰이 무엇인지 정확히 알리기 위해, "우리에게 없는 것"도 나열한다 —',
          ],
          checklist: {
            items: [
              '감사가 없다 — 컨트랙트는 너무 단순해 60줄 이내로 다 읽힌다. 표준 BEP-20에 LP 소각 추가.',
              '스테이킹 컨트랙트가 없다',
              '락업 메커니즘이 없다(LP 영구 소각은 제외)',
              '크로스체인 브리지가 없다',
              '거버넌스 토큰이 아니다 — ALLIN을 보유해도 투표권이 주어지지 않는다',
              '에어드롭 약속이 없다 — 한 번도 한다고 한 적 없으며 앞으로도 갑작스럽게 발표하지 않는다',
            ],
          },
          paragraphsTail: ['단순함이 이 토큰의 설계 원칙이다.'],
        },
      ],
    },

    {
      id: 'ch6',
      kind: 'chapter',
      number: 'VI',
      title: '이것은 무엇이 아닌가',
      paragraphs: [
        '이 장은 경계를 긋기 위함이다.',
        '암호화폐 세계에서 새 토큰은 매번 다음 질문 폭격을 받는다 — L1인가? 어떤 문제를 푸는가? 어떤 utility가 있는가? 어떤 프로젝트와 관계인가?',
        '모두가 다시는 묻지 않아도 되도록, 직접 답해 둔다.',
      ],
      subsections: [
        {
          id: 'ch6-1',
          number: 'i',
          title: 'ALLIN이 아닌 것',
          checklist: {
            items: [
              '**L1이 아니다** — 새로운 퍼블릭 체인이 아니라 BNB Chain 위의 BEP-20 토큰이다',
              '**DeFi 프로토콜이 아니다** — lending / swap / staking / yield 같은 금융 기능은 일체 없다',
              '**RWA 토큰이 아니다** — 어떤 현실 자산도 담보로 하지 않는다',
              '**거버넌스 토큰이 아니다** — 보유해도 프로젝트 투표권이 주어지지 않는다',
              '**유틸리티 토큰이 아니다** — 구체적인 "사용 시나리오"가 없다. 그것으로 어떤 기능도 풀 수 없고 어떤 상품도 살 수 없으며 어떤 서비스도 받을 수 없다',
              '**에어드롭 코인이 아니다** — 에어드롭 계획이 없다. "갑작스레 발표"되는 에어드롭도 없다',
              '**어떤 트렌드의 짜깁기도 아니다** — RWA / IDO / Restaking / DePIN, 이 모든 것과 ALLIN은 무관하다',
            ],
          },
        },
        {
          id: 'ch6-2',
          number: 'ii',
          title: '그렇다면 ALLIN은 무엇인가',
          paragraphs: [
            'ALLIN은 기념비다. 명단이다. 암호다.',
            '그 모든 가치는 보유자가 "꿰뚫어 봤다면 올인하라"는 정신에 동의하는 데서 온다. 수익을 약속하지 않고, 실용 기능이 없으며, 미래의 로드맵도 없다.',
            '투자 대상으로 들리지 않는다. 맞다, **본래 그런 것이 아니다**.',
          ],
          pullQuote: '그 가치는 금융적이지 않다, 문화적이다 — 이 정신에 동의하면 산다, 동의하지 않으면 떠난다.',
        },
        {
          id: 'ch6-3',
          number: 'iii',
          title: '리스크와 사법 관할',
          paragraphs: [
            '이 토큰은 0이 될 수 있다.',
            '어느 날 ALLIN 시장이 더 이상 이 정신을 믿지 않는다면, 가격은 0이 된다. 어느 날 커뮤니티 합의가 무너진다면, 가격은 0이 된다. 어느 날 규제가 이러한 종류의 커뮤니티 토큰을 완전히 금지한다면, 가격은 0이 된다.',
            '우리는 그 0을 100% 인지하고 있고, 그 "0이 될 가능성"을 모든 공개 자료에 적어 두었다.',
            '잃어도 견딜 수 있는 돈으로 걸어달라.',
            'ALLIN은 어느 사법 관할에서도 증권 청약이 아니다. 본 선언은 투자 자문, 청약, 매수 권유 어느 것도 구성하지 않는다. 당신이 거주하는 국가나 지역이 암호자산 보유를 금한다면, 현지 법률을 따르라. ALLIN은 명백히 암호 규제를 위반하는 시장에 자발적으로 진입하지 않는다.',
          ],
        },
      ],
    },

    {
      id: 'postscript',
      kind: 'chapter',
      number: '',
      title: '에필로그',
      paragraphs: [
        '여기까지 읽었다면 —',
        '당신은 〈올인 선언〉의 모든 내용을 안 셈이다. 서문, 왜 ALLIN인가, 세 가지 정신 원칙, 아홉 명의 이야기, 커뮤니티 공동 구축의 규칙, 메커니즘의 투명성, 그리고 이 토큰이 무엇이 아닌지를.',
        '더 이상 설득하지 않는다.',
        '이 글이 당신을 움직였다면, 테이블로 와도 좋다. ALLIN을 조금 사고, Telegram 커뮤니티에 가입하고, 주변의 올인 이야기를 우리에게 투고하라. 또는 아무것도 하지 않아도 좋다 — 다만 이 선언을, 지금 가장자리에서 망설이고 있는 친구 한 명에게 한 통 보내주기만 해도.',
        '이 글이 당신을 움직이지 않았다면, 그래도 괜찮다. 본래 모든 사람을 향한 글이 아니다.',
        '우리가 남기고 싶은 것은 10억 달러의 토큰이 아니다. 100년 뒤에도 누군가 읽고 있을 한 편의 문서다 — 이 세대에서 한 가지에 모든 것을 건 사람들을 기록하고, 그 순간의 그들의 용기를 기록하며, "올인"이라는 단어가 한 번은 진지하게, 정성스레, 비꼬임 없이 사용되었던 시기를 기록하는 문서.',
      ],
      pullQuote: '기록된다는 것은 오래된 보상의 형태다. 토큰보다 훨씬 오래되었고, 아마 훨씬 오래간다.',
      sign: '— ALLIN 커뮤니티, 2026년 봄',
    },
  ],
};
